import Calendar from '../../../collection/calendar';
import Collection from '../../../collection';
import View from '../../view';

import { nextMonth, beginMonth, beginYear, beginDay, 
    same, past,
    tomorrow,
    unixts, 
    fmt,
    monthDuration } from '../../../utils/date';






export default View.extend( {

    serialize() {
        const { pattern } = this.options;
        const dateSeed = beginYear( beginDay( this.options.year ) );

        return {
            calendars: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
                .map( monIndex => new Calendar( nextMonth( dateSeed, monIndex ) ) ),

            ['marker-color-scheme']: this.options['marker-color-scheme'],

            // как должен выглядеть реальный dates для calendar?
            // { date:X, ... }
            // X может быть как TimeStamp, так и строкой
            dates: new Collection( [
                ...Object.keys( pattern.v )
                    .map( date => ({
                        date,
                        pickedUp: true,
                        toggleOff: pattern.remove[date]
                    })),
                ...Object.keys( pattern.add )
                    .map( date => ({ 
                        date, 
                        pickedUp: true
                    }))
            ] )
        }
    },

    [View.event( ':date:toggle' )](date) {
        return toggleDate.call( this, date ), 
            this.render();
    },

    [View.event( ':month:toggle' )](month) {
        return toggleMonth.call( this, month ), 
            this.render();
    }

} );






function toggleDate(date) {
    if (past( date ))
        return;

    const { pattern, ...props } = this.model.clonePattern( this.options.pattern );
    pattern.value = [...this.options.pattern.value];
    pattern.v = { ...this.options.pattern.v };
    pattern.add = { ...this.options.pattern.add };
    pattern.remove = { ...this.options.pattern.remove };

    this.options.pattern = pattern;

    const finalize = () => this.model.set( props );

    if (pattern.add[fmt( date, 'DD.MM.YYYY' )])
        return delete pattern.add[fmt( date, 'DD.MM.YYYY' )], finalize();

    if (pattern.remove[fmt( date, 'DD.MM.YYYY' )])
        return delete pattern.remove[fmt( date, 'DD.MM.YYYY' )], finalize();

    if (pattern.v[fmt( date, 'DD.MM.YYYY' )])
        return pattern.remove[fmt( date, 'DD.MM.YYYY' )] = true, finalize();

    return pattern.add[fmt( date, 'DD.MM.YYYY' )] = true, finalize();
}

function toggleMonth(month) {
    const firstOfMonth = beginMonth( month );
    const contract = this.model.get( 'contract' );
    const startDate = contract && unixts( contract.start_date );
    const finishDate = contract && unixts( contract.finish_date );

    let onCount = 0, disabledCount = 0;
    const dates = [];
    for (let dt = firstOfMonth; same.month( dt, firstOfMonth ); dt = tomorrow( dt ))
        if (past( dt ))
            disabledCount++;
        else if (contract && (unixts( dt ) < startDate || unixts( dt ) > finishDate))
            disabledCount++;
        else {
            dates.push( dt );
            if (isOn( this.options.pattern, dt )) onCount++;
        }

    const needTurnOff = onCount + disabledCount === monthDuration( firstOfMonth );
    for (let dt of dates)
        if (isOn( this.options.pattern, dt ) == needTurnOff)
            toggleDate.call( this, dt );
}

function isOn({ v, add, remove }, date) {
    if (add[fmt( date, 'DD.MM.YYYY' )])
        return true;

    if (remove[fmt( date, 'DD.MM.YYYY' )])
        return false;

    return !!v[fmt( date, 'DD.MM.YYYY' )];
}




// WEBPACK FOOTER //
// ./src/js/view/module/schedule/pattern.random.js